// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"59790fc7","325":"f8fd44f8","482":"3ebb87aa","688":"04a30f99","954":"c3e2ee57"}[chunkId] + ".chunk.css";
};